import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { ReporteService } from 'src/app/services/reporte.service';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';


const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-ingresos-cuadro',
  templateUrl: './ingresos-cuadro.component.html',
  styleUrl: './ingresos-cuadro.component.scss',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class IngresosCuadroComponent {
 
  public data :any;
  public isLoadingResults = false;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  startDate: any;
  endDate: any;
 // public lstClubes: any;
 // public clubSelect: any;

 constructor(
  public reporteSvc: ReporteService,
 // public empresaSvc: EmpresaService,
  public disciplinaSvc: DisciplinaService,
  private alertify: AlertifyService
) {


}
ngAfterViewInit() {
  this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
    console.log(disLst);
    this.lstDisciplinas = disLst;
  });

/*   this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
    console.log(clubLst);
    this.lstClubes = clubLst;
  }); */


}

ngOnInit(): void {}

buscar() {
  if (this.startDate == null) {
    this.alertify.error('El periodo de busqueda no es valido (fecha desde)');
    return;
  }
  if (this.endDate == null) {
    this.alertify.error('El periodo de busqueda no es valido (fecha hasta)');
    return;
  }
  console.log(this.startDate.toDate());
  console.log(this.endDate.toDate());
  console.log(this.disciplinaSelect);

  this.getIngresos();
}

getIngresos() {
  this.isLoadingResults = true;
  this.reporteSvc
    .getIngresosCuadro(

      this.startDate.format('YYYY-MM-DDTHH:mm:ss'),
      this.endDate.format('YYYY-MM-DDTHH:mm:ss'),
      this.disciplinaSelect,
     // this.clubSelect,
    )
    .subscribe((result) => {
      this.isLoadingResults = false;
      this.data=result;
      console.log('resultado: ', result);
    });
}

}
